import React from "react";
import About from "../components/About";
import FAQS from "../components/FAQS";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Service from "../components/Service";
import SuccssesStories from "../components/SuccssesStories";
import HeroSectionII from "../components/HeroSectionII";

function Home() {
  return (
    <div className="h-auto w-full mx-auto scroll-smooth">
      <div className="hidden lg:block">
        <Header />
      </div>
      <HeroSectionII />
      <About />
      <Service />
      <SuccssesStories />
      <FAQS />
      <Footer />
    </div>
  );
}

export default Home;
